// ============================================
// ROLC OneROLC - Routes
// Version: 3.6.0
// ============================================

import { navigate } from './history.js';

// ============================================
// Route Helpers
// ============================================
export function navigateToSurvey(surveyName) {
    navigate('/survey', { name: surveyName });
}

export function navigateToLogin() {
    const pathname = window.location.pathname || '';
    if (!pathname.includes('login.html') && pathname !== '/login') {
        window.location.href = '/login.html';
    } else {
        navigate('/login');
    }
}

export function navigateToAdmin() {
    const pathname = window.location.pathname || '';
    if (!pathname.includes('admin-panel.html') && pathname !== '/admin-panel') {
        sessionStorage.setItem('rolc_admin_nav', '1');
        window.location.href = '/admin-panel.html';
    } else {
        sessionStorage.setItem('rolc_admin_nav', '1');
        navigate('/admin');
    }
}

export function navigateToHome() {
    const pathname = window.location.pathname || '';
    if (pathname.includes('admin-panel.html') || pathname === '/admin-panel' || 
        pathname.includes('login.html') || pathname === '/login') {
        sessionStorage.setItem('rolc_just_logged_in', '1');
        window.location.href = '/';
    } else {
        navigate('/');
    }
}

// ============================================
// Get page title
// ============================================
export function getPageTitle(path, params = {}) {
    const titles = {
        '/': 'ROLC OneROLC',
        '/survey': params.name ? `Survey: ${params.name}` : 'Survey',
        '/login': 'Login - ROLC OneROLC',
        '/admin': 'Admin Panel - ROLC OneROLC',
        '/rolcadmin': 'Admin Panel - ROLC OneROLC'
    };
    return titles[path] || 'ROLC OneROLC';
}


